export * from './IconEmployeeBadge';
export { default as IconEmployeeBadge } from './IconEmployeeBadge';
